export const reCAPTCHA_API_KEY = "6LdkTWwoAAAAACtem-fZ6oZrWwgmyR7SWk0jT_Lr"
